function socialMediaLinkedDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/social-media-linked/social-media-linked.html?$$REVISION$$'
  }
}

export { socialMediaLinkedDialog }
